export default {
  "OD": "OD",
  "OS": "OS",
  "Both": "Both",
  "male": 'Male',
  "female": 'Female',
  "yes": "Yes, continue with the original treatment plan",
  "exit": "No, discontinue treatment",
  "update": "Yes, but change the treatment plan",
  "logout": "Logout",
  "login": "Login Now",
  "title": "Real-world Registry Study of Red Light Therapy in Children with Refractory Myopia",
  "institution_id": "Institution ID",
  "study_id": "StudyID",
  "name": "Name",
  "ethnicity": "Ethnicity",
  "birthday": "Date of birth",
  "sex": "Gender",
  "password": 'Password',
  "treatment_history": "Prior treatment",
  "duration_of_treatment": "Duration of conventional treatment",
  "refractive_error_progression": "SER progression over 1 year",
  "axial_elongation": "axial elongation over 1 year",
  "initial_selection_results": "Initial selection results",
  "first_examination_results": "First examination results",
  "date_of_visit": "Date of visit",
  "axial_length": "Axial length",
  "subjective_refraction": "Subjective refraction",
  "spherical_diopter": "Spherical diopters",
  "cylindrical_diopter": "Cylindrical diopters",
  "axis_degree": "Axis",
  "cycloplegic_refraction": "Cycloplegic refraction",
  "best_corrected_visual_acuity": "Best corrected visual acuity (Decimal)",
  "visual_acuity_notes": "VA test specify",
  "adverse_reactions": "Self-reported side effect(s)",
  "continue_treatment": "Whether to continue treatment?",
  "reason_not_to_continue": "Reason not to continue",
  "new_treatment_plan": "New ongoing treatment",
  "oct_report_conclusion": "OCT report in photo or description",
  "research_team_introduction": "Research team introduction",
  "principal_investigator": "Principal investigator",
  "participant_login": "Participant login",
  "researcher_login": "Researcher login",
  "contact_us": "Contact us",
  "project_email": "Project email",
  "contact_person": "Contact person",
  "inquiries": "If you have any questions, you can ask our staff now or later, or contact Dr. Yan-Xian Chen (Phone: 852-27666111 / Email: yan-xian.chen@polyu.edu.hk) or Dr.Ziwei Zhao (Phone: 852-61548412 / Email: zavia.zhao@connect.polyu.edu.hk).",
  "complaints": "If you have any dissatisfaction or complaints about this study, you can email the Polytechnic University Institutional Review Board Secretary (institutional.review.board@polyu.edu.hk), clearly stating the principal investigator and department, as well as the reference number.",
  "institutional_review_board": "Polytechnic University Institutional Review Board Secretary",
  "yjtd_text": "The principal investigator, Prof. Mingguang He, is currently a Distinguished Chair Professor at The Hong Kong Polytechnic University and a visiting professor at the Zhongshan Ophthalmic Center, Sun Yat-sen University. He has previously served as a Professor at the Zhongshan Ophthalmic Center and as a Professor of Ophthalmology at the University of Melbourne. He is a recipient of the National Science Fund for Distinguished Young Scholars, a leading talent of the National 'Ten Thousand Talents Program', and a distinguished talent of the Guangdong Special Support Program ('Southern China Top 100'). He also serves as a board member of the Asia-Pacific Academy of Ophthalmology, secretary-general and board member of the Asia-Pacific Myopia Society, and deputy editor-in-chief of the British Journal of Ophthalmology. His research findings have been published in prestigious international journals such as The Lancet and JAMA. The research team has extensive experience in myopia control and global cooperation, and their achievements are widely recognized in academic circles. The team is committed to international collaboration to address the high prevalence of myopia globally and provide better vision health protection and services.",
  "yjxx_foot": "This project has been approved by the ethics committee of The Hong Kong Polytechnic University (Ref No. HSEARS20240113001).",
  "yjxx": "Research information",
  "yjtd": "Research team",
  "year": "Year",
  "month": "Month",
  "D_per_year": "D/year",
  "mm_per_year": "mm/year",
  "cylindrical_diopter": "DC",
  "axis_degree": "°",
  "mm": "mm",
  'atropine': 'Atropine eye drops',
  'ok': 'Orthokeratology',
  'dims': 'Defocus incorporated',
  'untreated': "Untreated",
  'others': 'Other',
  'asian': 'Asian',
  'black_african': 'Black/African',
  'caucasian_white': 'Caucasian (White)',
  'hhspanic_Latino': 'Hispanic/Latino',
  'middle_eastern': 'Middle Eastern',
  'native_american': 'Native American',
  'pacific_islander': 'Pacific Islander',
  'mixed_race': 'Mixed Race',
  'other': 'Other',
  'orthokeratology_RLRL': 'Orthokeratology+RLRL',
  'DIMS_RLRL': 'DIMS+RLRL',
  'DIMS_RLRL_therapy': "DIMS+RLRL",
  'orthokeratology_RLRL_therapy': 'Orthokeratology+RLRL',
  'Stop_conventional_treatments_and_switch_to_RLRL_therapy': 'Stop conventional treatments and switch to RLRL',
  'other_RLRL_therapy': 'RLRL + Other',
  'RLRL': 'RLRL',
  'unsuitable': 'Not applicable',
  'none': 'None',
  'worsened_visual_acuity': 'Worsened visual acuity',
  'central_scotoma': 'Central Scotoma',
  'prolonged_afterimage_5_minutes': 'Prolonged afterimage > 5 Minutes',
  'choose_an_alternative_treatment_plan': "Choose an alternative treatment plan",
  'patient_goes_to_another_clinic': 'Patient goes to another clinic',
  'patient_declines': 'Patient declines',
  'contraindications': 'Contraindications ',
  'follow_up_text': 'Follow-up {n} results',
  'date_of_rlrltherapy_commencement': "Start Date of RLRL",
  "yjxxdl": "Research Information Sheet (Chinese Version) Download",
  "yjxxdl_en": "Research Information Sheet (English Version) Download",
  "inform": "Informed Consent Signature Page Download",
  "edc_text": "Instructions for Web Data Entry for the Real-world Red Light Therapy Study (EDC)_Chinese Version",
  "edc_video": "Video Instructions for Web Data Entry for the Real-world Red Light Therapy Study（EDC)_Chinese Version",
  "edc_en_text": "Instructions for Web Data Entry for the Real-world Red Light Therapy Study (EDC)_English Version",
  "edc_en_video": " Video Instructions for Web Data Entry for the Real-world Red Light Therapy Study（EDC)_English Version",
  'whatchOnline': 'Watch Online',
  'Download': 'Download'
}
